module.exports = __webpack_public_path__ + "static/media/expressjs.20ad1ef0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/expressjs.png
// module id = 94
// module chunks = 0